import gql from 'graphql-tag'

export const locationGeometryDetailsQuery = gql`
  query LocationGeometryDetails($placeId: String!) {
    locationGeometryDetails(placeId: $placeId)
  }
`
